/** State seal in nav + footer — same visual weight as the creative lockup */
export const WV_STATE_SEAL_HEIGHT = { xs: 44, md: 48 };
